import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import ScrollWaypoint from '@costar/scroll-waypoint';
import React, { useCallback } from 'react';
import { useTabsContext } from './tabs-context.esm.js';
import { TAB_THEME_KEY } from './types.esm.js';
import { BoxPrivate } from '../_primitives/box/box.esm.js';
import { noop } from '../../utils/function.esm.js';

var _excluded = ["variant", "children", "value", "scrollOffset", "threshold"];
var TabPanel = function TabPanel(props) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'panel' : _props$variant,
    children = props.children,
    value = props.value,
    scrollOffset = props.scrollOffset,
    threshold = props.threshold,
    other = _objectWithoutProperties(props, _excluded);
  var _useTabsContext = useTabsContext(),
    tabVariant = _useTabsContext.variant,
    selection = _useTabsContext.selection,
    mode = _useTabsContext.mode,
    selectionChangedObserver = _useTabsContext.selectionChangedObserver;
  var onEnterHandler = useCallback(function () {
    if (value !== undefined) {
      selectionChangedObserver === null || selectionChangedObserver === void 0 ? void 0 : selectionChangedObserver.notify({
        value: value,
        source: 'panels'
      });
    }
  }, [selectionChangedObserver, value]);
  var content = /*#__PURE__*/React.createElement(BoxPrivate, _extends({
    role: "tabpanel",
    variant: tabVariant ? "".concat(tabVariant, ".").concat(variant) : variant,
    __themeKey: TAB_THEME_KEY,
    hidden: mode == 'switch' && selection !== value,
    id: "nav-tabpanel-".concat(value),
    "aria-labelledby": "nav-tab-".concat(value)
  }, other), mode === 'switch' ? selection === value ? children : null : children);
  return mode === 'stack' ? /*#__PURE__*/React.createElement(ScrollWaypoint, {
    enabled: true,
    eventKey: "".concat(value),
    onEnter: onEnterHandler,
    onLeave: noop,
    threshold: threshold
  }, /*#__PURE__*/React.createElement(BoxPrivate, {
    as: "span",
    id: "nav-scrollto-".concat(value),
    height: '0px',
    position: 'relative',
    top: "".concat(scrollOffset)
  }), content) : content;
};

export default TabPanel;
//# sourceMappingURL=tab-panel.esm.js.map
